export default __webpack_public_path__ + "static/media/Group 1157.3b93a447.webp";